import React, {useState, useEffect, useRef, lazy, Suspense} from "react";
import {connect, useDispatch} from "react-redux";
import {withRouter} from "../../../helpers/withRouter";
import T from "../../../shared/component/t/T";
import snippets from "../../../helpers/snippets";
import {default as _} from '../../../helpers/Translate';
import TextBox from "../../../shared/component/textbox/Textbox";
import {Editor, Viewer} from "@toast-ui/react-editor";
import '@toast-ui/editor/dist/toastui-editor.css';
import T_Vector from "../../../assets/images/T_Vector.svg"
import Exp_Vector from "../../../assets/images/Vector1.svg"
import Expressions from "./Expressions";
import Audio from "./Audio";
import {_loading} from "../../../actions/Loading";
import ModalImages from "./ModalImages";
import EditorSuggestionDropDown from "./EditorSuggestionDropDown";
import SpellCheck from "../../../core/api/SpellCheck/SpellCheck";
import ReportCP_SpellCheck from "./ReportCP_SpellCheck";
import AiComponent from "./AiComponent";
import {default as ai_vector} from "../../../assets/images/ai.svg"
const Templates = lazy(() => import('./Templates'));


const spellCheck = new SpellCheck()

function ReportCP_EditorViewer(props) {
	const dispatch = useDispatch()
	const [language] = useState(props.language)
	const [NewStudyReport, setNewStudyReport] = useState(props.NewStudyReport)
	const [images] = useState(props.images)
	const [expressions, setExpressions] = useState(props.expressions)
	const [selectedReport, setSelectedReport] = useState(props.selectedReport)
	
	const [editorKey, setEditorKey] = useState(props.reloadEditor)
	const editorRef = useRef(null)
	let editorTimer
	const [forbidChars] = useState(['`', '<br>'])
	
	const [expand, setExpand] = useState(true)
	const [modals, setModals] = useState({
		audio: false,
		images: false,
		templates: false,
		expressions: false,
		ai: false
	})
	const [listener, setListener] = useState({
		ctrl: false,
		enter: false,
		space: false,
	})
	const listenerRef = useRef(listener);

	
	const [suggestions, setSuggestions] = useState({
		show: false,
		text: '',
		suggestions: [],
		position: {top: 0, left: 0}
	})
	const [spellCheckModal, setSpellCheckModal] = useState({show: false})
	
	
	useEffect(() => {
		const handleDrop = (event, cursor) => {
			if (editorRef.current.rootEl.current.contains(event.target)) {
				event.preventDefault()
				event.dataTransfer.dropEffect = cursor; // 'none' will change the cursor to 'not-allowed'
			}
		};
		
		document.addEventListener("keydown", listeners)
		document.addEventListener("keyup", listeners)
		document.addEventListener('drop', (event) => handleDrop(event, "none"))
		document.addEventListener("dragover", (event) => handleDrop(event, "move"))
		
		return (() => {
			document.removeEventListener("keydown", listeners)
			document.removeEventListener("keyup", listeners)
			document.removeEventListener('drop', handleDrop)
			document.removeEventListener('dragover', handleDrop)
		})
	}, []);
	
	useEffect(() => {
		setExpressions(props.expressions)
	}, [props.expressions])
	
	useEffect(() => {
	}, [props.language])
	
	useEffect(() => {
		setNewStudyReport(props.NewStudyReport)
	}, [props.NewStudyReport])
	
	useEffect(() => {
		setSelectedReport(props.selectedReport)
	}, [props.selectedReport])
	
	useEffect(() => {
		//this is useful to use as key for enforce re-render editor when user changed selectedReportModal
		setEditorKey(props.editorKey)
	}, [props.editorKey])
	
	useEffect(() => {
		if (NewStudyReport?.can_edit === false) {
			console.log("destroy editor")
			editorRef?.current?.getInstance()?.destroy()
			handleCloseAllModal()
			setExpand(true)
		}
	}, [NewStudyReport?.can_edit])
	
	useEffect(() => {
		if (listener.ctrl && listener.enter) {
			handleShortcutSubstitution()
			resetListener()
		} else if (listener.ctrl && listener.space) {
			handleOneWordSpellCheck()
			resetListener()
		}
	}, [listener])
	
	useEffect(() => {
		if (suggestions.text?.length > 3) {
			// const timeout = setTimeout(() => {textSpellCheck()}, 500)
			// return () => clearTimeout(timeout);
		} else {
			closeSuggestionsDropDown()
		}
	}, [suggestions?.text]);
	
	useEffect(() => {
		if (suggestions.suggestions?.length) {
			setSuggestions(prevState => ({...prevState, show: true}))
		}
	}, [suggestions?.suggestions]);
	
	useEffect(() => {
		if(!suggestions.show){
			editorRef?.current?.getInstance()?.focus()
		}
	}, [suggestions.show]);
	
	const textSpellCheck = () => {
		let data = {text: suggestions.text}
		spellCheck.check(data)
			.then(response => {
				setSuggestions(prevState => ({...prevState, suggestions: response?.data?.suggestions}))
			})
	}
	
	const closeSuggestionsDropDown = () => {
		setSuggestions(prevState => ({...prevState, show: false}))
	}
	
	const spellCheckClicked = () => {
		setSpellCheckModal(prevState => ({...prevState, show: true}))
	}
	const SpellCheckModalClose = () => {
		setSpellCheckModal(prevState => ({...prevState, show: false}))
	}
	
	const changes = (target, value) => {
		props.onChange(target, value)
	}
	
	const batchChanges = (list) => {
		props.changeValuesArray(list)
	}
	
	const textBoxChanges = (e) => {
		changes(e.target.name, e.target.value)
	}
	
	
	// we do debounce because change the editor to markdown / Wysiwyg runs onChange function. indeed this function runs 3 time
	// so first value on editor fixed for this.state.NewStudyReport on parental component. because first value of editor is current editor text
	// so if user only insert template and save that, findings has no changes for data which is sent to server ```
	const editorChanges = () => {
		if (!snippets.isObjectEmpty(editorTimer)) {
			clearTimeout(editorTimer)
		}
		editorTimer = setTimeout(propEditorValue, 100);
		return () => clearTimeout(editorTimer)
	}
	
	const keyDownReplaceForbiddenChars = (text) => {
		return text.replace(/\\*`*/g, '') // Removes all backticks
			.replace(/<br>/g, '') // Removes all new lines
	}
	
	const existForbidChars = (text)=> {
		let exists = forbidChars.map(item => text.includes(item))
		return exists.some(item => item)
	}
	
	const propEditorValue = () => {
		let content
		if (editorRef.current.getInstance().isWysiwygMode() || editorRef.current.getInstance().isMarkdownMode()) {
			content = editorRef.current.getInstance().getMarkdown()
			if (existForbidChars(content)) {
				let replaced = keyDownReplaceForbiddenChars(content)
				return refreshEditor(replaced)
			}
			changes("findings", content)
		} else {
			content = editorRef.current.getInstance().getHTML();
			console.warn('why HTML mode?', content)
			changes("findings", content)
		}
		
		// manually add contenteditable as false to tables in tui editor
		// <table> first time changes to <table contentEditable=false> so other times this condition is false! times that query select becomes less.
		if (!snippets.isObjectEmpty(content) && editorRef.current?.getInstance().getHTML().includes("<table>")) {
			const tables = Array.from(document.querySelectorAll('table'));
			const tablesWithImages = tables?.filter(table => table.querySelector('tbody img'));
			tablesWithImages.forEach((table) => {
				const parentDiv = table.closest(".ProseMirror.toastui-editor-contents");
				if (parentDiv) {
					table.setAttribute("contenteditable", "false");
				}
			});
		}
	};
	
	const rtlClick = () => {
		let someProperty = {}
		if (NewStudyReport?.direction === "rtl") {
			someProperty['rtl'] = false
			someProperty['direction'] = "ltr"
			props.changeValuesArray(someProperty)
		} else if (NewStudyReport?.direction === "ltr") {
			someProperty['rtl'] = true
			someProperty['direction'] = "rtl"
			props.changeValuesArray(someProperty)
		}
	}
	
	const refreshEditor = (text) => {
		console.log("refresh Editor")
		if (!snippets.isObjectEmpty(editorRef) && NewStudyReport?.can_edit !== false) {
			try {
				editorRef.current?.getInstance().changeMode("markdown")
				editorRef.current?.getInstance().moveCursorToEnd()
				let end = editorRef.current?.getInstance().getSelection()
				editorRef.current?.getInstance().deleteSelection([1, 1], end[0])
				editorRef.current?.getInstance().insertText(text)
				editorRef.current?.getInstance().changeMode("wysiwyg")
				editorRef.current?.getInstance().moveCursorToEnd()
				dispatch(_loading(false))
			} catch {
				console.log("refresh Editor got into catch block")
				dispatch(_loading(true))
				setTimeout(() => {
					console.log('Retrying fetchData...');
					refreshEditor(text)
				}, 1000);
			}
		}
	}
	
	const handleModalsAndCollapseButton = (modal) => {
		if (expand === true) {
			setModals({...modals, [modal]: !modals[modal]})
			setExpand(false)
		} else {
			let lastOpenButton = modals.expressions ? "expressions" :
				modals.templates ? "templates" :
					modals.audio ? "audio" :
						modals.ai ? 'ai' : ""
			if (modals[modal] === true && lastOpenButton === modal) {
				handleCollapseButtons(modal)
			} else {
				setModals({...modals, [modal]: true, [lastOpenButton]: false})
			}
		}
	}
	
	const handleCollapseButtons = (button) => {
		setModals({...modals, [button]: false})
		setExpand(true)
	}
	
	const handleCloseModal = (modal) => {
		setModals({...modals, [modal]: false})
	}
	
	const handleCloseAllModal = () => {
		setModals({
			audio: false,
			images: false,
			templates: false,
			expressions: false,
			ai: false
		})
	}
	
	const handleOpenModal = (modal) => {
		setModals({...modals, [modal]: true})
	}
	
	const buttonsDiv = () => {
		if (expand === false && modals.expressions === true) {
			return <Expressions onClose={() => handleCollapseButtons("expressions")}
			                    study={NewStudyReport}
			                    getOnlineExpressions={() => expressions}
			/>
		} else if (expand === false && modals.templates === true) {
			return TemplatesLazyLoad()
		} else if (expand === false && modals.audio === true) {
			return <Audio onClose={() => handleCollapseButtons("audio")}
			              studyId={props.params.studyID}
			              reportId={selectedReport}
			              hasAudio={NewStudyReport.has_audio}
			              voices={NewStudyReport?.voices}
				// update={()=>handleCreateNewReportRedirect()} //to load new audio uploaded
			/>
		}
	}
	
	const handleKeyUp = () => {
		const selection = window.getSelection();
		if (selection.rangeCount > 0) {
			const range = selection.getRangeAt(0);
			const rect = range.getBoundingClientRect();
			const offsetTop = rect.top + window.pageYOffset;
			const offsetLeft = rect.left + window.pageXOffset;
			
			const editorContainer = editorRef.current.getRootElement();
			// const parentEditorContainer = editorContainer.parentElement
			// parentEditorContainer.style.position = 'relative'
			const editorContentPositions = editorContainer.getBoundingClientRect()
			const relativeTop = Math.max(0, offsetTop - editorContentPositions.top + 20);
			const relativeLeft = Math.max(0, offsetLeft - editorContentPositions.left - 10);
			
			setSuggestions(prevState => ({
				...prevState,
				...handleNewSuggestionValues(),
				position: {top: relativeTop, left: relativeLeft}
			}))
		}
	};
	
	const handleNewSuggestionValues = () => {
		let obj = {...suggestions}
		let lastWord = getLastWord()?.[0]
		if (lastWord !== obj.text){
			obj['text'] = lastWord
			obj['suggestions'] = []
		}
		return obj
	}
	
	const handleKeyListenerValues = (event, propertyName) => {
		const isKeyDown = event.type === "keydown";
		const isKeyUp = event.type === "keyup";
		if (isKeyDown) {
			setListener((prevState) => {
				listenerRef.current = {...prevState, [propertyName]: true};
				return listenerRef.current;
			});
		} else if (isKeyUp && listenerRef.current[propertyName]) {
			setListener((prevState) => {
				listenerRef.current = {...prevState, [propertyName]: false};
				return listenerRef.current;
			});
		}
	}
	
	const listeners = (event) => {
		//todo: get text by mouse movements.
		if (event.srcElement.className.includes("ProseMirror")) {
			if (event?.key === "Control" && event?.keyCode === 17) {
				handleKeyListenerValues(event, 'ctrl')
			}
			else if (event?.key === "Enter" && event?.keyCode === 13 ) {
				event.preventDefault();
				handleKeyListenerValues(event, 'enter')
			}
			else if (event.code === "Space" && event.keyCode === 32) {
				handleKeyListenerValues(event, 'space')
			}
			handleKeyUp()
		}
	}
	
	const resetListener = () => {
		setTimeout(() => {
			setListener({ctrl: false, enter: false, space: false})
		}, 50)
	}
	
	const getLastWord = () => {
		let event = editorRef.current?.getInstance().isMarkdownMode() === true ? "markdown" : "wysiwyg"
		let a = editorRef.current?.getInstance().getSelection();
		if (event === "markdown") {
			let line = a[0][0]
			let current = a[0][1]
			let lineTillCursor = editorRef.current?.getInstance().getSelectedText([line, 1], [line, current]).toString()
			let d = lineTillCursor.split(" ");
			let myWordToCursor = d[d.length - 1];
			let myWordToCursorStartIndex = lineTillCursor.lastIndexOf(myWordToCursor)
			if (myWordToCursor.length > 0) {
				return [myWordToCursor, [line, myWordToCursorStartIndex + 1], [line, current]]
			}
		} else if (event === "wysiwyg") {
			let range = editorRef.current?.getInstance().getRangeInfoOfNode().range
			let current = a[1]
			let lineTillCursor = editorRef.current?.getInstance().getSelectedText(range[0], current).toString()
			let myWords = lineTillCursor.split(" ")
			let myWordToCursor = myWords[myWords.length - 1]
			let myWordToCursorStartIndex = lineTillCursor.lastIndexOf(" ") + range[0]
			if (myWordToCursor.length > 0) {
				return [myWordToCursor, myWordToCursorStartIndex + 1, current]
			}
		}
	}
	const handleOneWordSpellCheck = () => {
		let lastWord = getLastWord()?.[0]
		if (lastWord !== undefined && lastWord !== suggestions.text) {
			console.error("suggestions.text is not as same as last word")
		}
		if (listener.ctrl && listener.space && lastWord?.length > 0) {
			textSpellCheck()
		}
	}
	
	const handleSpellCheckSubstitution = (proppedLastWord, replaceWith) => {
		let [lastWord, start, end] = getLastWord()
		if (lastWord !== proppedLastWord)
			return console.error("last word and what you propped to replace does not match", lastWord, proppedLastWord)
		if (replaceWith.length <= 0)
			return console.error("the word that must be substitute does not valid: ", replaceWith)
		
		let event = editorRef.current?.getInstance().isMarkdownMode() === true ? "markdown" : "wysiwyg"
		if (event === "markdown") {
			editorRef.current?.getInstance().replaceSelection(replaceWith, start, end)
		} else if (event === "wysiwyg") {
			editorRef.current?.getInstance().replaceSelection(replaceWith, start, end)
		}
	}
	
	const handleShortcutSubstitution = () => {
		let event = editorRef.current?.getInstance().isMarkdownMode() === true ? "markdown" : "wysiwyg"
		let [lastWord, start, end] = []
		try{
			[lastWord, start, end] = getLastWord()
		} catch (e){
			return console.error("ReportCP_EditorViewer -> last word not found to substitute")
		}
		if (event === "markdown") {
			if (listener.enter && listener.ctrl && lastWord.length > 0) {
				expressions.forEach(element => {
					if (lastWord === element.shortcut) {
						editorRef.current?.getInstance().replaceSelection(element.expression, start, end)
					}
				});
			}
		} else if (event === "wysiwyg") {
			if (listener.enter && listener.enter && lastWord.length > 0) {
				expressions.forEach(element => {
					if (lastWord === element.shortcut) {
						editorRef.current?.getInstance().replaceSelection(element.expression, start, end)
					}
				});
			}
		}
	}
	
	const changeFindings = (findings) => {
		changes('findings', findings)
		props.reloadEditor()
	}
	
	const templatesFunc = () => {
		return (<>
			<div className={`circle ${modals.templates ? "clicked" : ""}`}
			     title={_.init("templates", language)}
			     onClick={() => handleModalsAndCollapseButton("templates")}
			>
				<img src={Exp_Vector} alt=""/>
			</div>
		</>)
	}
	
	const TemplatesLazyLoad = () => {
		let lst = new Set([
			NewStudyReport?.verifier_id,
			NewStudyReport?.typist_id,
			NewStudyReport?.reporter_id,
			NewStudyReport?.resident2_id,
		].filter(item => item !== null && item !== -1))
		lst = Array.from(lst);
		
		return (
			<Suspense fallback={loadingComponent()}>
				<Templates onClose={() => handleCollapseButtons("templates")}
				           editorRef={editorRef}
				           reportModality={NewStudyReport?.main_modality_id}
				           getOnlineValue={(e) => {
					           return NewStudyReport[e]
				           }}
				           changeValuesArray={batchChanges}
				           reporters={[...lst]}
				/>
			</Suspense>
		);
	}
	
	const loadingComponent = () => {
		return <div className={"right_div_loading"}><T token={"loading"}/></div>
	}
	
	
	return (
		<>
			<div className="reportTypeDiv" id={'reportTypeDiv'}>
				<div className='reportTypeDiv__right'>
					<div className={`reportTypeDiv__right__title`}>
						<div className={"__title"}><T token={"description_name"}/></div>
					</div>
					<div className={`reportTypeDiv__right__findings`}>
						<i className={'fal fa-microscope fa-2x'}/>
						<T token={"findings"}/>
					</div>
					<div className={`reportTypeDiv__right__impression`}>
						<div className={"__title"}><T token={"impression"}/></div>
					</div>
				</div>
				<div className={`__middle ${expand ? "" : '-collapseToRight'}`}>
					<div className={"description_name"}>
						<TextBox className={"description_name"}
						         name={"description_name"}
						         changeValue={textBoxChanges}
						         value={NewStudyReport?.description_name}
						         placeholder={_.init(`report_title`, language)}
						         disable={!NewStudyReport?.can_edit_title}
						         direction={NewStudyReport?.direction}
						/>
					</div>
					{NewStudyReport?.can_edit ?
						<div className={`editor ${NewStudyReport?.direction}`}>
							{/* todo: autoCorrection */}
							{/* todo: use SpaxEditor: I'd tried to but i have problems on passing ref to it! */}
							<Editor
								id="editor"
								key={editorKey}
								spellCheck={true}
								initialValue={NewStudyReport?.findings}
								placeholder={_.init(`findings`, language)}
								ref={editorRef}
								minHeight='100%'
								height='100%'
								initialEditType="wysiwyg"
								hideModeSwitch={true}
								useCommandShortcut={true}
								autoFocus={true}
								onChange={editorChanges}
								previewHighlight={true}
								toolbarItems={[
									[
										// "heading",
										"bold",
										"italic",
										// "strike"
									], [
										"table",
										// "image",
										// "link"
									]
								]}
							/>
							{props.device === 'desktop' && <div className={"rtlOrLtr"}
							     onClick={() => rtlClick()}
							>
								{NewStudyReport.direction === "rtl" ?
									<i className="fal fa-paragraph-rtl fa-2x" title={_.init("ltr", language)}/>
									:
									<i className="fal fa-paragraph fa-2x" title={_.init("rtl", language)}/>
								}
							</div>}
							
							{props.device === 'desktop' && <div className={"editor_spell_check"}
							      onClick={spellCheckClicked}
							>
								<i className="fal fa-spell-check fa-2x" title={_.init("spell_check", language)}/>
							</div>}
							{suggestions?.show &&
								<EditorSuggestionDropDown show={suggestions.show}
								                          direction={NewStudyReport?.direction}
								                          text={suggestions?.text}
								                          options={suggestions?.suggestions}
								                          position={suggestions?.position}
								                          close={closeSuggestionsDropDown}
								                          replacement={handleSpellCheckSubstitution}
								/>
							}
						</div>
						:
						<div
							className={`viewer ${expand ? "" : '-collapseToRight'} ${NewStudyReport?.rtl ? "rtl" : "ltr"}`}>
							<Viewer
								initialValue={NewStudyReport?.findings || ""}
								height='95%'
								width='95%'
							/>
						</div>
					}
					<div className={"impression"}>
						<TextBox className="impression"
						         changeValue={textBoxChanges}
						         type={"textarea"}
						         name={'impression'}
						         label={<T token={'impression'}/>}
						         placeholder={_.init(`impression_placeholder`, language)}
						         value={NewStudyReport?.impression}
						         disable={!NewStudyReport?.can_edit}
						         direction={NewStudyReport?.direction}
						/>
					</div>
				</div>
				<div className={`__left_right${expand ? "" : '-expandToRight'}`}>
					{buttonsDiv()}
				</div>
				{NewStudyReport?.can_edit && <>
					<div className='__left'>
						{NewStudyReport?.dictaphone ?
							<div className={`circle ${modals.audio ? "clicked" : ""}`}
							     title={_.init("voice_report", language)}
							     onClick={() => handleModalsAndCollapseButton("audio")}
							>
								<i className={'fal fa-microphone-alt fa-2x'}/>
							</div>
							:
							<div className={`circle disabled`}
							     title={NewStudyReport?.dictaphone_disable_reason}
							>
								<i className={'fal fa-microphone-alt fa-2x'}/>
							</div>}
						
						{images.length !== 0 && <div className="circle"
						                             title={_.init("images", language)}
						                             onClick={() => handleOpenModal("images")}>
							<i className={'fal fa-images fa-2x'}/>
						</div>}
						
						{templatesFunc()}
						
						<div className={`circle ${modals.expressions ? "clicked" : ""}`}
						     title={_.init("expressions", language)}
						     onClick={() => handleModalsAndCollapseButton("expressions")}
						>
							<img src={T_Vector} alt=""/>
						</div>
						
						<div className={`circle ${NewStudyReport?.ai_permission ? '' : 'disabled'}`}
							 title={NewStudyReport?.ai_permission
								 ? _.init("ai", language)
								 : _.init("ai_disable_reason", language)}
							 onClick={NewStudyReport?.ai_permission
								 ? () => handleOpenModal("ai")
								 : () => {}
							 }
						>
							<img src={ai_vector} alt={''} width={28} style={{color: "white"}}/>
						</div>
					</div>
				</>}
			</div>
			
			{modals.images && <ModalImages
				show={modals.images}
				images={images}
				editor={editorRef}
				onClose={() => handleCloseModal("images")}
			/>}
			
			{spellCheckModal.show && <ReportCP_SpellCheck show={spellCheckModal.show}
			                                              NewStudyReport={NewStudyReport}
			                                              closeModal={SpellCheckModalClose}
			                                              changeFindings={changeFindings}
			/>}
			
			{modals.ai && <AiComponent showModal={modals.ai}
							           closeModal={()=>handleCloseModal("ai")}
			                           imgs={images}
			                           NewStudyReport={NewStudyReport}
			/>}
		
		</>
	)
}

const mapStateToProps = state => {
	const language = state.LangReducer.language;
    const device = state.DeviceModeReducer.mode;
	return {language, device};
};

export default connect(mapStateToProps)(withRouter(ReportCP_EditorViewer));